import cookie from "../../lib/cookie";
import Cookie from "../../lib/cookie";
import Vue from 'vue'

const jsonParse = function(jsonStr,def){
  let res;
  try{
    res = JSON.parse(jsonStr);
  }catch(err){
    res = def;
  }
  return res;
}

const jsonStringify = function(json){
  return JSON.stringify(json)
}

const state = {
  userInfo: null,
  sessionId: null,
  firstUrl: '',
  currentUrl: '',
  uuids: jsonParse(Cookie.get('user_uuids'),{})||{},
}



const mutations = {
  SET_USER_INFO(state,value){
    if(typeof value !== 'object'){
      throw new Error('userInfo is not an object')
    }
    state.userInfo = value
  },
  // UNSET_USER_INFO(state){
  //   state.userInfo = null
  // },
  SET_SESSIONID(state, value){
    if(typeof value !== 'string'){
      throw new Error('sessionId is not a string')
    }
    state.sessionId = value
  },
  SET_FIRSTURL(state, value){
    if(typeof value !== 'string'){
      throw new Error('firstUrl is not a string')
    }
    state.firstUrl = value
  },
  SET_CURRENTURL(state, value){
    if(typeof value !== 'string'){
      throw new Error('currentUrl is not a string')
    }
    state.currentUrl = value
  },
  SET_UUIDS(state, value){
    // state.uuids = value
    Vue.set(state,'uuids',value)
  }
}

const actions = {
  setUserInfo({commit},value){
    commit('SET_USER_INFO',value)
  },
  // unsetUserInfo({commit}){
  //   commit('UNSET_USER_INFO')
  // },
  setSessionId({ commit }, value){
    commit('SET_SESSIONID', value)
  },

  setFirstUrl({ commit },value){
    commit('SET_FIRSTURL', value)
  },
  setCurrentUrl({ commit },value){
    commit('SET_CURRENTURL', value)
  },
  setUUIDS({ commit },{value,key}){
    let data = state.uuids;
    if(!state.uuids){
      data = {};
    }
    data[key] = value;
    cookie.set('user_uuids',jsonStringify(data),{ expires: 1/24,path: '/' })
    commit('SET_UUIDS', data)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js